import { render, staticRenderFns } from "./ExternalBrokerHome.vue?vue&type=template&id=0b59fab6"
import script from "./ExternalBrokerHome.vue?vue&type=script&lang=js"
export * from "./ExternalBrokerHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports